import { useEffect, useState } from "react";

// routing
import Routes from "@routes";

// project imports
import Locales from "@uiComponent/Locales";
import NavigationScroll from "@layout/NavigationScroll";
import RTLLayout from "@uiComponent/RTLLayout";
import Snackbar from "@uiComponent/extended/Snackbar";
import Loader from "@uiComponent/Loader";

import ThemeCustomization from "@themes";
import { dispatch } from "@store";
import { getDashboard } from "@store/slices/menu";

// auth provider
// import { FirebaseProvider as AuthProvider } from "@contexts/FirebaseContext";
// import { Auth0Provider as AuthProvider } from '@contexts/Auth0Context';
// import { AWSCognitoProvider as AuthProvider } from '@contexts/AWSCognitoContext';
import { JWTProvider as AuthProvider } from "@contexts/JWTContext";

// ==============================|| APP ||============================== //

const App = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getDashboard()).then(() => {
      setLoading(true);
    });
  }, []);

  if (!loading) return <Loader />;

  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <NavigationScroll>
            <AuthProvider>
              <>
                <Routes />
                <Snackbar />
              </>
            </AuthProvider>
          </NavigationScroll>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
